var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-tooltip',{attrs:{"placement":"top-start","content":_vm.content}},[_c('i',{staticClass:"iconfont yx-color-text-regular icon-a-help-circle-obangzhu-xian mr-2"})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }